const money = (value) => {
  if (value === undefined || value === null || value === "") return null;
  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};
const round = (value) => Math.round((value + Number.EPSILON) * 100) / 100;

export function getBusinessTaxRate(business) {
  if (!business) return null;
  const metadata = Array.isArray(business.meta_data)
    ? Object.fromEntries(business.meta_data.map(({ meta_key, meta_value }) => [meta_key, meta_value]))
    : business.meta_data || {};
  const rates = ["business_tax", "business_conv_tour_tax"].map((key) => {
    const value = metadata[key] ?? business[key];
    return value == null || value === "" ? 0 : money(value);
  });
  if (rates.some((rate) => rate === null || rate < 0 || rate > 100)) return null;
  return round(10 + rates[0] + rates[1]);
}

export function getOrderTaxSummary(order = {}, business) {
  let snapshot = order.tax_breakdown;
  if (typeof snapshot === "string") {
    try { snapshot = JSON.parse(snapshot); } catch { snapshot = null; }
  }
  const total = money(order.total_price_order ?? order.total);
  const delivery = money(order.delivery_price ?? order.deliveryPrice) ?? 0;
  const tip = money(order.tip) ?? 0;
  let subtotal = money(order.subtotal);
  const items = order.detail ?? order.orderItems;
  if (subtotal === null && Array.isArray(items)) {
    subtotal = items.reduce((sum, item) => {
      const savedTotal = money(item.total_price ?? item.price);
      if (savedTotal !== null) return sum + savedTotal;
      const extras = (item.extras || []).reduce(
        (amount, extra) => amount + Number(extra.price || 0) * Number(extra.quantity ?? 1), 0
      );
      return sum + (Number(item.dish_price || 0) + extras) * Number(item.dish_quantity || 0);
    }, 0);
  }
  const snapshotFees = money(snapshot?.totalFees);
  const amount = snapshotFees ?? (
    total !== null && subtotal !== null ? round(total - subtotal - delivery - tip) : null
  );
  if (subtotal === null && total !== null && amount !== null) {
    subtotal = round(total - delivery - amount - tip);
  }
  const fees = Array.isArray(snapshot?.fees) ? snapshot.fees : null;
  // Prefer historical rates; use the business configuration when none were saved.
  const recordedRates = fees?.map((fee) => money(fee.rate));
  const rate = recordedRates?.length && recordedRates.every((value) => value !== null)
    ? round(recordedRates.reduce((sum, value) => sum + value, 0))
    : money(snapshot?.totalRate) ?? getBusinessTaxRate(business);
  return { subtotal, total, delivery, tip, amount, rate, fees };
}

export function formatOrderTaxes(summary) {
  if (summary.amount === null) return "Unavailable";
  const amount = `$${summary.amount.toFixed(2)}`;
  return summary.rate === null ? amount : `${amount} (${summary.rate}%)`;
}
